import { render, staticRenderFns } from "./MailForwarding.vue?vue&type=template&id=3b857374"
import script from "./MailForwarding.vue?vue&type=script&lang=js"
export * from "./MailForwarding.vue?vue&type=script&lang=js"
import style0 from "./MailForwarding.vue?vue&type=style&index=0&id=3b857374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports